import React from 'react';
import { Stack } from '@fluentui/react';
import { Copy20Regular } from '@fluentui/react-icons';
import { PillButton } from 'common/components/Buttons/v8';
import { getDownloadLink } from 'features/device/DeviceHelpers';
import { useLocalizedStrings } from 'i18n';

import { useShareAction } from './useShareAction';

export const CopyLinkComponent = ({ telemetryProps }: { telemetryProps?: Record<string, string | null> }) => {
  const { t } = useLocalizedStrings('devices');
  const downloadLink = React.useMemo(() => getDownloadLink() || '', []);

  // i18next-extract-mark-ns-start devices

  const copyLink = React.useCallback(() => navigator.clipboard.writeText(downloadLink), [downloadLink]);

  const icon = <Copy20Regular />;

  const shareAction = useShareAction(copyLink, {
    pending: t('AddDevice.Dialog.Share.Notifications.Copying'),
    success: t('AddDevice.Dialog.Share.Notifications.Copied'),
    failed: t('AddDevice.Dialog.Share.Notifications.CopyFailed'),
  });

  return (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }}>
      <PillButton
        text={t('AddDevice.Dialog.Share.CopyLink')}
        telemetryEventName="AddDeviceCopyDownloadLinkCopyButtonClicked"
        telemetryProps={telemetryProps}
        onClick={shareAction}
        onRenderIcon={() => icon}
      />
    </Stack>
  );

  // i18next-extract-mark-ns-stop devices
};
